<p-dialog
[(visible)]="loading"
[showHeader]="false"
[resizable]="false"
[modal]="true"
[focusOnShow]="false"
class="progress-overlay"
>
<div style="width: 200px; height: 150; padding-top: 5%" class="text-center">
  <p-progressSpinner 
    [style]="{ width: '50px', height: '50px' }"
  ></p-progressSpinner>
  <!-- <h6 class="mt-3">Fetching Audit Records</h6> -->
</div>
</p-dialog>
<div class="inputSwitch">
    <span [pTooltip]="type==='pie' ? 'Switch to User Risk Score History Chart' : 'Switch to User Risk Score Pie Chart' " tooltipPosition="bottom">
        <p-toggleswitch [ngModel]="isPieChart" (onChange)="chartViewSwitch($event.checked)"></p-toggleswitch>
    </span>
</div>
<div class="card risk-score-chart">
    <p-chart [type]="type" [height]="500" [data]="data" [label]="label" [options] = 'chartOptions'></p-chart>
</div>
<div id="riskTableBoxes">
<div class="titles">
    <h4 class="highRiskTitle" style="font-size: 20px; margin-bottom: -10px;">Peer Audit Table</h4>
</div>
    <p-table #highRiskP2PTable [columns]="highRiskP2PCols" [value]="highRiskP2P">
        <ng-template pTemplate="header">
            <tr >
                <th *ngFor="let col of highRiskP2PCols" [pSortableColumn]="col.field" class="tableHeaderStyle">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" class="arrows"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <br />
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr tabindex="0" class="table-row-clickable" [ngStyle]="ColorAssignmentP2P(rowData.backgroundColor)"  (click)="openP2PFilteredTable(rowData)">
                <td *ngFor="let col of columns">
                    {{ col.displayField ? rowData[col.displayField] : rowData[col.field] }}
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div class="titles">
    <h4 class="highRiskTitle" style="font-size: 20px; margin-top: 10px; margin-bottom: -10px;">Variance Table</h4>
</div>
    <p-table #highRiskResoTable [columns]="highRiskResoCols" [value]="highRiskResolutions">
        
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of highRiskResoCols" [pSortableColumn]="col.field" class="tableHeaderStyle">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" class="arrows"></p-sortIcon>
                </th>
            </tr>
            
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr tabindex="0" class="table-row-clickable" [ngStyle]="ColorAssignment(rowData.backgroundColor)" (click)="openURCFilteredTable(rowData)">
                <td *ngFor="let col of columns">
                    {{ col.displayField ? rowData[col.displayField] : rowData[col.field] }}
                </td>
            </tr>
        </ng-template>
    </p-table>
    

</div>

<p-dialog
    [style]="{width: '90vw', height: '32vw', 'overflow-y': 'scroll'}"
    class="popUpHeader"
    [(visible)]="showP2PTable"
    appendTo="body"
    [maximizable]="true"
    header="Peer Analytics Details">
    <app-data-filter-pills [filterValues]="peerFilter" (filterVal)="removePeerFilter($event)"></app-data-filter-pills>
    <app-analytics-table
        #p2pFilteredTable
        *ngIf="showP2PTable"
        [chartFilter]="peerFilter"
        [locId]="location"
        [headerEnabled]="true"
        (filterValue)="getFilterPillsValues($event)"
></app-analytics-table>
</p-dialog>

<p-dialog
    [style]="{width: '90vw', height: '32vw'}"
    class="popUpHeader"
    [(visible)]="showURCTable"
    appendTo="body"
    [maximizable]="true"
    header="Individual Activity">
    <app-data-filter-pills [filterValues]="iaFilter" (filterVal)="removeIaFilter($event)"></app-data-filter-pills>
    <app-urc
        #varianceComponent
        *ngIf="showURCTable"
        [auditRow]="URCFilter"
        [headerEnabled]="true"
        (filterValue)="getFilterPillsValues($event)"
        (shareIndvActiv)="shareIndividualActivity($event)"
    ></app-urc>
</p-dialog>
